module.exports = __webpack_public_path__ + "img/i-cards-gold.26ff6b8a.svg";